import { VesselMessage } from '../../../../types/VesselMessage';
import { VesselProductMessage } from '../../../../types/VesselProductMessage';
import { Modal } from '../../../cdl/Modal/Modal';
import { TableBuilder } from '../../../cdl/TableBuilder/TableBuilder';
import { TableBuilderColumn } from '../../../cdl/TableBuilder/TableBuilderColumn';
import { Tag } from '../../../cdl/Tag/Tag';
import { Text } from '../../../cdl/Text/Text';
import { formatDate } from '../../../common/helpers/formatDate.helper';
import { translate } from '../../../common/helpers/translate.helper';
import { useEnums } from '../../../common/hooks/useEnums';
import { Box } from '../../../common/ui/Box';

interface ViewVesselProductsModalProps {
    isOpen: boolean;
    onDismiss: () => void;
    vessel: VesselMessage;
    vesselProducts: VesselProductMessage[];
}

export const ViewVesselProductsModal = ({
    isOpen,
    onDismiss,
    vessel,
    vesselProducts,
}: ViewVesselProductsModalProps) => {
    const { getHumanReadableValue } = useEnums();

    return (
        <Modal isOpen={isOpen} onDismiss={onDismiss} width={1200} scrollable>
            <Box padding={24} display="grid" rowGap={24}>
                <Text variant="title">
                    {translate('order.lubes.viewProducts.title', {
                        vesselName: vessel.name,
                        vesselImo: vessel.imo,
                    })}
                </Text>

                <TableBuilder data={vesselProducts} grow={false}>
                    <TableBuilderColumn<VesselProductMessage>
                        header={translate('vessel.products.productName')}
                        width="25%"
                    >
                        {(vesselProduct) => (
                            <Box display="flex" alignItems="center" gap={8}>
                                <Text>{vesselProduct.product.name}</Text>
                                {vesselProduct.isInTank ? (
                                    <Tag variant="accent">{translate('vessel.products.inTank')}</Tag>
                                ) : null}
                            </Box>
                        )}
                    </TableBuilderColumn>
                    <TableBuilderColumn<VesselProductMessage>
                        header={translate('vessel.products.supplierName')}
                        width="10%"
                        truncate
                    >
                        {(vesselProduct) =>
                            getHumanReadableValue('supplierProductGroup', vesselProduct.product.supplierProductGroup)
                        }
                    </TableBuilderColumn>
                    <TableBuilderColumn<VesselProductMessage>
                        header={translate('vessel.products.productGroup')}
                        width="15%"
                        truncate
                    >
                        {(vesselProduct) => getHumanReadableValue('productGroup', vesselProduct.product.group)}
                    </TableBuilderColumn>
                    <TableBuilderColumn<VesselProductMessage>
                        header={translate('vessel.products.dateCreated')}
                        width="10%"
                    >
                        {(vesselProduct) => formatDate({ date: vesselProduct.dateCreated })}
                    </TableBuilderColumn>
                    <TableBuilderColumn<VesselProductMessage>
                        header={translate('vessel.products.dateUpdated')}
                        width="10%"
                    >
                        {(vesselProduct) => formatDate({ date: vesselProduct.dateUpdated })}
                    </TableBuilderColumn>
                    <TableBuilderColumn<VesselProductMessage>
                        header={translate('vessel.products.note')}
                        width="20%"
                        truncate
                    >
                        {(vesselProduct) => vesselProduct.note}
                    </TableBuilderColumn>
                </TableBuilder>
            </Box>
        </Modal>
    );
};
